var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

FIGURE.visitParallax = function() {
	const heroBg = $(".parallax.hero-section .carousel")
	if (heroBg.length) {
		$(window).on("scroll", () => {
			const scrolled = window.pageYOffset;
			const parallaxSpeed = 0.5; // Adjust this value (0-1) for parallax intensity
			heroBg.css({"top": `${scrolled * parallaxSpeed}px`});
		});
	}
}();

FIGURE.expander = function() {
	const $expander = $('.expander');
	if ($expander.length) {
		$(window).on("scroll", () => {
			//Window positioning
			const windowHeight = $(window).height();
			const scrollTop = $(window).scrollTop();
			const scrollPos = windowHeight + scrollTop;

			//Expander positioning
			const expanderPos = $expander.offset().top;
			const expanderCustomPoint = expanderPos + (windowHeight * 2 / 3);
			const expanderMidPoint = expanderPos + ($expander.outerHeight() / 2);
			const expanderEndPoint = expanderPos + $expander.outerHeight();

			const $expanderImg = $expander.find('img');

			const isVisible = scrollPos >= expanderPos && scrollPos <= (expanderEndPoint + windowHeight);

			// console.log({ expanderPos, scrollPos, expanderMidPoint, isVisible });
			if (isVisible) {
				if (expanderCustomPoint > scrollPos) {
					const ratio = 1 - (expanderCustomPoint - scrollPos) / (expanderCustomPoint - expanderPos);
					console.log({ratio, expanderCustomPoint, scrollPos});
					$expander.css({'width': `${90 + (ratio * 10)}%`});
					$expanderImg.css({'width': `${135 - (ratio * 35)}%`});
				} else {
					console.log("second half of expander is visible");
				}
			}
		});
	}
}();
